/**
* @file 搜索
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FC, useEffect, useState} from 'react';
import useSearchInput from '@/hooks/useSearchInput';
import {FlattenItem} from '@/hooks/useSearchInput/flattenTree';
import Panel from './Panel';

type SearchInputProps = {
    dataSource: FlattenItem[]
}

const placeholder = 'Search titles with keywords';

const SearchInput: FC<SearchInputProps> = ({
    dataSource,
}) => {
    const {domRef, visible, keyword, result, handleInputChange} = useSearchInput(dataSource);
    const [focus, setFocus] = useState(false);

    const handleFocus = (e :any) => {
        setFocus(true);
        e.target.value !== placeholder && handleInputChange(e);
    };

    return (
        <div className="search" ref={domRef}>
            <input
                onChange={handleInputChange}
                placeholder={placeholder}
                onFocus={handleFocus}
                onBlur={() => setFocus(false)}
                className={keyword ? 'active' : ''}
                value={keyword || focus ? keyword : placeholder}
            />
            {visible ? <Panel items={result} keyword={keyword} /> : null}
        </div>
    );
};

export default SearchInput;
